import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import $ from "jquery";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 0,
    maxWidth: 585,
    marginTop: "0px",
    float: "left",
  },
}))(Tooltip);

const styles = () => ({
  option: {
    fontSize: 13,
    padding: 5,
    fontWeight: 500,
  },
});

class AutoComplete1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: this.props.value,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isDisabled) {
      $("#" + nextProps.isDisabled)
        .parent()
        .css("background-color", "#DCDCDC");
    } else {
      $("#" + nextProps.name)
        .parent()
        .css("background-color", "#FFFFFF");
    }

    if (prevState.tooltip && nextProps.value !== prevState.tooltip.value) {
      return {
        tooltip: nextProps.value,
      };
    }
  }

  render() {
    if (this.props.marginLeft == null) {
      $("#" + this.props.name)
        .parent()
        .css("margin-left", this.props.margin ? this.props.margin : "0px");
    }

    return (
      <React.Fragment>
        {/* {this.props.label? (
          <div
            style={{
              marginBottom: "-1px",
              marginTop: "0.23rem",
              marginRight: "18px",
              lineHeight: "inherit",
              fontWeight: "500",
              paddingLeft: "3px",
              fontSize: this.props.fontSize ? this.props.fontSize : "13px",
              marginLeft: this.props.margin ? this.props.margin : "0px",
            }}
          >
            {this.props.label}
          </div>
        ) : null} */}

        <LightTooltip
          id="tool"
          title={this.state.tooltip ? this.state.tooltip.label : ""}
        >
          <Autocomplete
            multiple={this.props.multiple}
            freeSolo={this.props.freeSolo}
            ListboxProps={{ style: { maxHeight: "15rem" } }}
            id={this.props.name}
            size="small"
            style={{
              width: this.props?.width ? this.props?.width : "",
            }}
            disableClearable
            defaultValue={this.props.defaultValue}
            disabled={this.props.disabled}
            name={this.props.name}
            options={this.props.options}
            getOptionLabel={(option) => option.label}
            value={
              this.state.tooltip ? this.state.tooltip : this.props.defaultValue
            }
            onChange={(event, newValue) => {
              if (newValue === null) {
                return;
              }
              this.setState({ tooltip: newValue });
              this.props.handleChange(newValue, this.props.name, this.props.vo);
            }}
            //hi

            renderInput={
              this.props.dashboard != "eventCalender"
                ? (params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={this.props.error ? this.props.error : false}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "off",
                        spellcheck:"false",
                        "aria-autocomplete":"both",
                        "aria-haspopup":"false",
                        style: {
                          height: this?.props?.height
                            ? this?.props?.height
                            : "",
                          fontSize: this?.props?.fontSize
                            ? this?.props?.fontSize
                            : "12px",
                        },
                      }}
                      label={this.props.label ? this.props.label : ""}
                    />
                  )
                : (params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      label={
                        this.props.label && !this.props.show
                          ? this.props.label
                          : ""
                      }
                      error={
                        this.props.dashboard === "eventCalender" &&
                        this.props.error
                      }
                    />
                  )
            }
            // renderInput={(params) => <TextField {...params} variant="outlined" />}
            renderOption={(option) => (
              <React.Fragment>{option.label}</React.Fragment>
            )}
            className={this.props.className}
            classes={{
              option: this.props.classes.option,
            }}
          />
        </LightTooltip>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AutoComplete1);
